import { render, staticRenderFns } from "./platform-sell.vue?vue&type=template&id=c1661e50"
import script from "./platform-sell.vue?vue&type=script&lang=js"
export * from "./platform-sell.vue?vue&type=script&lang=js"
import style0 from "./platform-sell.vue?vue&type=style&index=0&id=c1661e50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports